
import React, { useState } from 'react';
import { Button, Col, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { UserListTable } from '../components/usermanagement/UserListTable';
import { UserModal } from './usermanagement/UserModal.js';
import { useRoles } from '../hooks/userManagement';

const { Option } = Select;

/**
 * UserAdminView – entry view for managing users in Core/Public services.
 *
 * @returns {JSX.Element}
 */
export const UserAdminView = () => {
  const coreService = "core";
  const publicService = "Public";
  const allRoles = { key: "-", value: "All Roles" };
  const backOffice = "Back-Office";

  const [users, setUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [hasUpdated, setHasUpdated] = useState(true);
  const [serviceType, setServiceType] = useState(coreService);
  const [selectedRole, setSelectedRole] = useState(allRoles);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalRecord, setModalRecord] = useState(null);
  const [modalViewOnly, setModalViewOnly] = useState(false);

  const viewOnly = serviceType !== coreService;
  const serviceUsersLabel = viewOnly ? "Public Web" : backOffice;
  
  const { data: roles = [] } = useRoles(serviceType, {
    includeAllRoles: viewOnly,
    allRoles: allRoles.value,
  });

  const openModal = (record = null, overrideViewOnly = viewOnly) => {
    setModalRecord(record);
    setModalViewOnly(overrideViewOnly);
    setModalOpen(true);
  };

  // Emit key from Select; find by key
  const onChangeRole = (roleKey) => {
    const found = (roles || []).find((r) => r.key === roleKey) || allRoles;
    setSearchText('');
    setSelectedRole(found);
  };

  // Grouped states
  const dataState = { users, setUsers, filteredData, setFilteredData };
  const filterState = { searchText, setSearchText };
  const serviceState = { serviceType, setServiceType, coreService, publicService, backOffice };
  const rolesState = { allRoles, selectedRole };
  const syncState = { hasUpdated, setHasUpdated };

  return (
    <>
      <div className="content">
        <Col xs={24}>
          <h1 className="center-align">{serviceUsersLabel} User Management</h1>
        </Col>

        {serviceType === coreService && (
          <>
            <Button
              className="add-button"
              key="bt1"
              type="primary"
              onClick={() => openModal()}
              icon={<PlusOutlined />}
            >
              {""} Add New User
            </Button>
          </>
        )}
        {(serviceType !== coreService) && (
          <div className="filter-role"
            style={{
              margin: "10px auto 0px auto",
              fontSize: "16px",
              // fontWeight: "bold",
            }}
          >
            User Role: {""}
            <Select key="filter-role"
              value={selectedRole?.key}
              style={{ width: "170px" }}
              placeholder="Please select role"
              onChange={onChangeRole}
            >
              {(roles || []).map((role) => (
                <Option
                  key={`${role.key ?? role.value}__${role.value}`}
                  value={role.key}
                >
                  {role.value}
                </Option>
              ))}
            </Select>
          </div>
        )}

        <UserModal
          key="user-modal"
          show={modalOpen}
          onShow={setModalOpen}
          record={modalRecord}
          viewOnly={modalViewOnly}
          roles={roles || []}
          setHasUpdated={setHasUpdated}
        />

        <UserListTable
          dataState={dataState}
          filterState={filterState}
          serviceState={serviceState}
          rolesState={rolesState}
          syncState={syncState}
          onOpenModal={openModal}
          viewOnly={viewOnly}
        />
      </div>
    </>
  );
};
